import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#d9ebff',
      main: '#d9ebff',
      dark: '#7ebbff',
      contrastText: '#fff',
    },
    secondary: {
      light: '#d9ebff',
      main: '#2cb5fa',
      dark: '#7ebbff',
      contrastText: '#fff',
    },
  },
});

export default theme;
